import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=18d023e7&scoped=true"
import script from "./ManageProduct.vue?vue&type=script&lang=js"
export * from "./ManageProduct.vue?vue&type=script&lang=js"
import style0 from "./ManageProduct.vue?vue&type=style&index=0&id=18d023e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d023e7",
  null
  
)

export default component.exports